<div [chart]="chart" [class]="graphClass"></div>
